import React from "react";
import { Routes, Route } from "react-router-dom";
import Footer from "./Layout/Footer";
import BuySell from "./Pages/BuySell";
import History from "./Pages/History";
import Homepage from "./Pages/Homepage";
import Settings from "./Pages/Settings";
import SettingsAccount from "./Pages/SettingsAccount";
import SettingsPreferences from "./Pages/SettingsPreferences";
import SettingsSecurity from "./Pages/SettingsSecurity";
import Signin from "./Pages/Signin";
import Signup from "./Pages/Signup";
import { Navigate } from "react-router-dom";
import ProtectedRoute from "./Pages/ProtectedRoute";
import ContactUs from "./Pages/ContactUs";

const Markup = () => {
  return (
    <div id="main-wrapper" className="dashboard">
      <Routes>
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Homepage />
            </ProtectedRoute>
          }
        />
        <Route path="/home" element={<Homepage />} />
        <Route path="/buysell" element={<BuySell />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/settingsAccount" element={<SettingsAccount />} />
        <Route path="/settingsPreferences" element={<SettingsPreferences />} />
        <Route path="/settingsSecurity" element={<SettingsSecurity />} />
        <Route path="/signin" element={<Signin />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/history" element={<History />} />
        <Route path="*" element={<Navigate to="/signin" />} />
      </Routes>
      <Footer />
    </div>
  );
};

export default Markup;
